module.exports = __webpack_public_path__ + "img/liverpool-logo-icon.b249a0c4.png";